/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import api from '../../utils/api';

export const uploadPersonAvatar = async (body: FormData) => {
  const res = await api
    .uploadImage('/cos/upload', body);
  return res.data;
};
